import React, { useState } from 'react'
import styled from 'styled-components'
import { Button } from 'antd'
import TrendsContainer from '../trends'

const Container = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  margin: 24px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  height: 500px;
  display: flex;
  flex-direction: column;

  .trends-header {
    margin-bottom: 20px;
    
    .trends-title {
      font-size: 18px;
      font-weight: 600;
      color: #383e48;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
    }

    .trends-summary {
      font-size: 14px;
      color: #6d7d8c;
      line-height: 1.5;
      margin-bottom: 16px;
    }
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 60px 0;
  }

  .empty-container {
    padding: 40px 0;
    text-align: center;
  }

  .trends-content {
    background: white;
    border-radius: 6px;
    padding: 16px;
    overflow-x: auto;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
    
    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
      height: 6px;
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #cbd2d9;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
      background: #9aa5b1;
    }
  }
`

const ClientTrendsSummary = ({ person }) => {
  const [showGraphType, setShowGraphType] = useState('bar')

  return (
    <Container>
      <div className="trends-header">
        <div className="trends-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>Trends Summary</span>
          <div style={{ display: 'flex' }}>
            <Button
              type={showGraphType === 'bar' ? 'primary' : 'default'}
              onClick={() => setShowGraphType('bar')}
              style={{ marginRight: '8px' }}
            >
              Bar Chart
            </Button>
            <Button
              type={showGraphType === 'line' ? 'primary' : 'default'}
              onClick={() => setShowGraphType('line')}
            >
              Line Chart
            </Button>
          </div>
        </div>
        <div className="trends-summary">
          Shows metrics with significant changes (±10% or more) over the last 90 days.
        </div>
      </div>
      <div className="trends-content">
        <TrendsContainer 
          person={person}
          onlySignificant={true}
          showGraphType={showGraphType}
          switchGraphType={setShowGraphType}
        />
      </div>
    </Container>
  )
}

export default ClientTrendsSummary
